import MobileNavItemInterface from './MobileNavItemInterface'
import * as React from 'react'
import { styled } from '../../../../stitches.config'
import NextLink from 'next/link'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { IconButton } from '../Buttons/IconButton'
import { useRouter } from "next/router";
import { useEffect } from "react";

const MobileNavToggleWrapper = styled('div', {
    display: 'flex',
    p: 10,
    '@md': {
        display: 'none',
    },
})
const MobileNavToggle = styled(IconButton, {
    cursor: 'pointer',
    fontSize: '$7',
    position: 'relative',
    zIndex: 1,
})
const DrawerContentWrapper = styled('div', {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
    '@md': {
        display: 'none',
    },
})

const MobileNavDrawer: React.FC<{
    mobileNavItems: MobileNavItemInterface[]
}> = ({ mobileNavItems }) => {
    const [isOpen, setIsOpen] = React.useState(false)
    const closeDrawer = () => {
        setIsOpen(false)
    }
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
    }
    const router = useRouter()
    useEffect(() => {
        router.events.on('routeChangeComplete', closeDrawer)
        return () => {
            router.events.off('routeChangeComplete', closeDrawer)
        }
    }, [router.events])

    return (
        <MobileNavToggleWrapper>
            <MobileNavToggle
                data-testid="hamburger-menu-icon"
                variant="ghost"
                onClick={toggleDrawer}
            >
                <FontAwesomeIcon icon={faBars}></FontAwesomeIcon>
            </MobileNavToggle>
            <Drawer
                open={isOpen}
                onClose={toggleDrawer}
                direction="left"
                className="mobile-nav-drawer"
                customIdSuffix="_pgc_mobile_nav_drawer"
            >
                <DrawerContentWrapper>
                    {mobileNavItems.map((mobileNavItem) => (
                        <NextLink
                            href={mobileNavItem.url}
                            passHref
                            key={mobileNavItem.url}
                        >
                            <a
                                key={mobileNavItem.url}
                                data-testid={mobileNavItem.test_id ?? ''}
                            >
                                {mobileNavItem.label}
                            </a>
                        </NextLink>
                    ))}
                </DrawerContentWrapper>
            </Drawer>
        </MobileNavToggleWrapper>
    )
}

export default MobileNavDrawer
